module.exports = __webpack_public_path__ + "img/fossilImg1.6cc10329.jpg";